<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/table'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import { eventComputed, eventListMethod, authComputed } from '@state/helpers'

export default {
  page: {
    title: 'Event List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Table },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      lists: [],
      fields: [
        { key: 'name', label: 'Name', sortable: true, colType: 'default' },
        { key: 'date', label: 'Event Date', sortable: true, colType: 'date' },
        { key: 'time', label: 'Time', sortable: false, colType: 'date' },
        { key: 'type', label: 'Type', sortable: true, colType: 'default' },
        {
          key: 'category.name',
          label: 'Category',
          sortable: true,
          colType: 'default',
        },
        { key: 'action', title: 'Action', sortable: false, colType: 'button' },
      ],
      displayFields: [
        { key: 'name', label: 'Name', colType: 'default' },
        { key: 'features', label: 'Features', colType: 'list' },
        { key: 'topics', label: 'Topics', colType: 'list' },
        { key: 'description', label: 'Description', colType: 'html' },
        { key: 'overview', label: 'Overview', colType: 'html' },
        { key: 'type', label: 'Type', colType: 'default' },
        { key: 'date', label: 'Date', colType: 'date' },
        { key: 'time', label: 'Time', colType: 'time' },
        { key: 'createdAt', label: 'Published On ', colType: 'date' },
      ],
    }
  },
  computed: {
    ...eventComputed,
    ...authComputed,
  },
  mounted() {
    this.getListOfEvents()
  },
  methods: {
    ...eventListMethod,

    // Get list of all events role wise
    getListOfEvents() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 10,
        sort: 'sort_order',
        order: '-1',
        status: 'pending',
      }
      this.fetchEventList({ filter })
        .then((eventList) => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <Table
              :items="eventList.docs ? eventList.docs : []"
              :fields="fields"
              :bordered="true"
              :viewbtn="true"
              :deletebtn="false"
              :editbtn="false"
              :addbtn="true"
              :per-page="eventList.limit"
              :total-rows="eventList.totalDocs"
              :current-page="eventList.page"
              :display-fields="displayFields"
              :total-page="eventList.totalPages"
              :paging-counter="eventList.pagingCounter"
            ></Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
